import React, { Component } from "react";
import {
  NormalButton,
  NormalSelect,
  NormalCheckbox,
  NormalInput,
  NormalModal,
  NormalTextarea,
  InputSearch,
  NormalTable,
  NormalButtonBackend,
} from "component/common";
import "./style.scss";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { withTranslation } from "react-i18next";
import {
  SiteGroups,
  NewSiteGroups,
  ItemSitelists,
  NewItemSitelists,
  Cities,
  States,
  Countries,
  SmtpList,
  updateCommon,
  NewSmtpList,
  UpdateSmtpList,
} from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { BsPencilSquare } from "react-icons/bs";
import closeIcon from "assets/images/close.png";
import { Toast } from "service/toast";

export class SmtpsettingClass extends Component {
  state = {
    SiteDetails: [
      {
        label: "Site Code",
      },
      // {
      //   label: "Active",
      // },
      {
        label: "Sender Name",
      },
      {
        label: "Email Subject",
      },
      {
        label: "Server Host",
      },
      {
        label: "User Email",
      },
    ],
    smtp_list: [],
    site_list: [],
    site: "",
    iscreation: false,
    islist: false,
    address: "",
    server_host: "",
    port: "",
    user_email: "",
    password: "",
    sender_name: "",
    email_subject: "",
    email_content: "",
    sms_content: "",
    updateId: null,
    edit: false,
  };

  componentDidMount = () => {
    this.ListofSmtplist({});
    this.Listofsitelist();
  };
  Listofsitelist = async () => {
    this.updateState({ is_loading: true });
    await this.props.ItemSitelists().then((res) => {
      console.log(res, "res");
      let { site_list } = this.state;
      for (let key of res) {
        site_list.push({ value: key.itemsiteId, label: key.itemsiteDesc });
      }
      console.log(site_list, "siteList");
      this.setState({
        site_list,
        is_loading: false,
      });
    });
  };
  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  ListofSmtplist = async () => {
    this.updateState({ is_loading: true });
    await this.props.SmtpList().then((res) => {
      console.log(res);
      let { smtp_list } = this.state;

      smtp_list = res.data.dataList;
      console.log(smtp_list, "smtpList");
      this.setState({
        smtp_list,
        is_loading: false,
      });
    });
  };

  temp = ({ target: { value, name } }) => {
    console.log(value, name);
    let {
      site,
      address,
      server_host,
      port,
      user_email,
      sender_name,
      email_content,
      email_subject,
      sms_content,
      password,
    } = this.state;
    if (name == "site") {
      site = +value;
      this.setState({ site });
      console.log(site, "sitee");
    }
    if (name == "address") {
      address = value;
      this.setState({ address });
    }
    if (name == "server_host") {
      server_host = value;
      this.setState({ server_host });
    }
    if (name == "port") {
      port = value;
      this.setState({ port });
    }
    if (name == "user_email") {
      user_email = value;
      this.setState({ user_email });
    }
    if (name == "sender_name") {
      sender_name = value;
      this.setState({ sender_name });
    }
    if (name == "email_content") {
      email_content = value;
      this.setState({ email_content });
    }
    if (name == "email_subject") {
      email_subject = value;
      this.setState({ email_subject });
    }
    if (name == "sms_content") {
      sms_content = value;
      this.setState({ sms_content });
    }
    if (name == "password") {
      password = value;
      this.setState({ password });
    }
    console.log(this.state, "stateValues");
  };
  sitecontent() {
    this.setState({
      iscreation: !this.state.iscreation,
    });
  }
  listcontent() {
    this.setState({
      islist: !this.state.islist,
    });
  }
  createsitelist = async () => {
    let {
      site,
      address,
      server_host,
      port,
      user_email,
      sender_name,
      email_content,
      email_subject,
      sms_content,
      password,
    } = this.state;
    if (site == "" || sender_name == "") {
      Toast({
        type: "error",
        message: "Please check required field",
      });
    } else {
      let newreason = {
        sender_name,
        sender_address: address,
        smtp_serverhost: server_host,
        port,
        user_email,
        user_password: password,
        email_subject,
        email_content,
        sms_content,
        site_codeid: site,
      };
      console.log(newreason, "newReason");
      await this.props
        .NewSmtpList(newreason)
        .then((data) => {
          this.ListofSmtplist({});
        })
        .catch((e) => console.log(e));
      this.sitecontent();
      this.listcontent();
    }
  };

  updatesitelist = async () => {
    let {
      site,
      address,
      server_host,
      port,
      user_email,
      sender_name,
      email_content,
      email_subject,
      sms_content,
      password,
      updateId,
      edit,
    } = this.state;
    if (site == "" || sender_name == "") {
      Toast({
        type: "error",
        message: "Please check rquired field",
      });
    } else {
      let newreason = {
        sender_name,
        sender_address: address,
        smtp_serverhost: server_host,
        port,
        user_email,
        user_password: password,
        email_subject,
        email_content,
        sms_content,
        site_codeid: site,
      };
      await this.props
        .UpdateSmtpList(`${updateId}/`, newreason)
        .then(() => {
          this.ListofSmtplist({});
        })
        .catch((e) => console.log(e));

      sender_name = "";
      site = "";
      address = "";
      server_host = "";
      port = "";
      user_email = "";
      email_content = "";
      email_subject = "";
      sms_content = "";
      password = "";
      this.setState({
        site,
        address,
        server_host,
        port,
        user_email,
        sender_name,
        email_content,
        email_subject,
        sms_content,
        password,
        edit: false,
      });

      //  this.newdescpopup();
    }
  };
  handleedit = async (itemcode) => {
    let {
      site,
      address,
      server_host,
      port,
      user_email,
      sender_name,
      email_content,
      email_subject,
      sms_content,
      password,
      edit,
      updateId,
    } = this.state;
    edit = true;
    this.setState({ edit });
    console.log(edit, "edit");
    await this.props.SmtpList().then((res) => {
      console.log(res.data.dataList, "response");

      let editObject = res.data.dataList.find(
        (obj) => obj.site_codeid === itemcode
      );
      console.log(editObject, "obj");
      updateId = editObject.id;
      sender_name = editObject.sender_name;
      address = editObject.sender_address;
      server_host = editObject.smtp_serverhost;
      port = editObject.port;
      user_email = editObject.user_email;
      password = editObject.user_password;
      email_subject = editObject.email_subject;
      email_content = editObject.email_content;
      sms_content = editObject.sms_content;
      site = editObject.site_codeid;
      this.setState({
        address,
        server_host,
        port,
        user_email,
        sender_name,
        email_content,
        email_subject,
        sms_content,
        password,
        site,
        updateId,
      });
    });
    this.setState({
      iscreation: true,
    });
  };
  handleCheckboxChange(index) {
    let { smtp_list } = this.state;
    const newData = smtp_list.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          isactive: true,
        };
      } else {
        return {
          ...item,
          isactive: false,
        };
      }
    });

    this.setState({
      smtp_list: newData,
    });
    console.log(smtp_list, "smtp");
  }

  render() {
    let {
      SiteDetails,
      pageMeta,

      is_loading,

      desc,
      iscreation,
      islist,
      smtp_list,
      post_code,
      email,
      fax,
      phoneone,
      phonetwo,
      city,
      country,
      state,
      cityval,
      stateval,
      countryval,
      site_list,
      site,
      address,
      server_host,
      port,
      user_email,
      sender_name,
      email_content,
      email_subject,
      sms_content,
      password,
      edit,
    } = this.state;
    let { t } = this.props;

    return (
      <>
        <div className="container-fluid tax bg-white">
          <div className="row">
            <h4 className="mt-3 text-center col-12 text-md-left label-head">
              {t("SMTP Setting")}
            </h4>
          </div>
          <div
            className="d-flex justify-content-between p-3 itemstatusgroup"
            onClick={() => this.sitecontent()}
          >
            <p>{t("Smtp Settings Creation")}</p>
            <div className="icons">
              {iscreation == false ? <AiOutlinePlus /> : <AiOutlineMinus />}
            </div>
          </div>

          {iscreation == true ? (
            <div className="container-fluid roomcontent">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="mt-3">
                    <p>
                      {t("Site ")}
                      <span style={{ color: "red" }}>*</span>
                    </p>
                    <div className="input-group">
                      <NormalSelect
                        options={site_list}
                        value={site}
                        name="site"
                        onChange={this.temp}
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("Sender Address")}</p>
                    <div className="input-group">
                      <NormalInput
                        value={address}
                        name="address"
                        placeholder="Enter Sender Address"
                        onChange={this.temp}
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("SMTP Server Host")}</p>
                    <div className="input-group">
                      <NormalInput
                        value={server_host}
                        name="server_host"
                        placeholder="Enter SMTP Server Host"
                        onChange={this.temp}
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("SMTP Port")}</p>
                    <div className="input-group">
                      <NormalInput
                        value={port}
                        name="port"
                        placeholder="Enter SMTP Port"
                        onChange={this.temp}
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("User Email")}</p>
                    <div className="input-group">
                      <NormalInput
                        value={user_email}
                        name="user_email"
                        placeholder="Enter User Email"
                        onChange={this.temp}
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("User Password")}</p>
                    <div className="input-group">
                      <NormalInput
                        value={password}
                        name="password"
                        placeholder="Enter User Password"
                        onChange={this.temp}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="mt-3">
                    <p>
                      {t("Sender Name")} <span style={{ color: "red" }}>*</span>
                    </p>
                    <div className="input-group">
                      <NormalInput
                        value={sender_name}
                        name="sender_name"
                        placeholder="Enter Sender Name"
                        onChange={this.temp}
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("E-mail Subject")}</p>
                    <div className="input-group">
                      <NormalInput
                        value={email_subject}
                        name="email_subject"
                        placeholder="Enter E-mail Subject"
                        onChange={this.temp}
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("E-mail Content")}</p>
                    <div className="input-group">
                      <NormalTextarea
                        onChange={this.temp}
                        value={email_content}
                        placeholder="Enter E-mail Content"
                        cols={4}
                        rows={4}
                        name="email_content"
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("SMS Content")}</p>
                    <div className="input-group">
                      <NormalTextarea
                        onChange={this.temp}
                        placeholder="Enter SMS Content"
                        cols={4}
                        rows={4}
                        value={sms_content}
                        name="sms_content"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {!edit ? (
                <div className="mt-3 col-12 col-md-2 p-0">
                  <NormalButtonBackend
                    mainbg={true}
                    label={"Add"}
                    onClick={() => this.createsitelist()}
                  />
                </div>
              ) : (
                <div className="mt-3 col-12 col-md-2 p-0">
                  <NormalButtonBackend
                    mainbg={true}
                    label={"Update"}
                    onClick={() => this.updatesitelist()}
                  />
                </div>
              )}
            </div>
          ) : (
            ""
          )}

          <div
            className="d-flex  justify-content-between p-3 itemstatusgroup mt-5"
            onClick={() => this.listcontent()}
          >
            <p>{t("SMTP Settings List")}</p>
            <div className="icons">
              {islist == false ? <AiOutlinePlus /> : <AiOutlineMinus />}
            </div>
          </div>
          {islist == true ? (
            <div className="tab-table-content">
              <div className="d-md-flex">
                <h5 className="mt-3 label-title col-12 text-center text-md-left text-lg-left p-0">
                  {t("List of SMTP Setting")}
                </h5>
              </div>

              <div className="py-4">
                <div className="table-container">
                  <NormalTable
                    headerDetails={SiteDetails}
                    queryHandler={this.handlePagination}
                    pageMeta={pageMeta}
                  >
                    {is_loading ? (
                      <tr>
                        <td colSpan="7">
                          <div class="d-flex mt-5 align-items-center justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : smtp_list.length > 0 ? (
                      smtp_list.map(
                        (
                          {
                            site_codeid,
                            sender_name,
                            smtp_serverhost,
                            user_email,
                            email_subject,
                            isactive,
                          },
                          index
                        ) => {
                          return (
                            <tr key={index}>
                              <td>
                                <div
                                  className="text-left text-primary cursor-pointer"
                                  onClick={() => this.handleedit(site_codeid)}
                                >
                                  {site_codeid}
                                </div>
                              </td>
                              {/* <td>
                                <div className="text-left text-primary cursor-pointer">
                                  <NormalCheckbox
                                    onChange={() =>
                                      this.handleCheckboxChange(index)
                                    }
                                    checked={isactive}
                                  />
                                </div>
                              </td> */}
                              <td>
                                <div className="text-left">{sender_name}</div>
                              </td>
                              <td>
                                <div className="text-left">{email_subject}</div>
                              </td>
                              <td>
                                <div className="text-left">
                                  {smtp_serverhost}
                                </div>
                              </td>
                              <td>
                                <div className="text-left">{user_email}</div>
                              </td>
                            </tr>
                          );
                        }
                      )
                    ) : null}
                  </NormalTable>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      SiteGroups,
      NewSiteGroups,
      ItemSitelists,
      SmtpList,
      NewItemSitelists,
      Cities,
      States,
      Countries,
      updateCommon,
      NewSmtpList,
      UpdateSmtpList,
    },
    dispatch
  );
};

export const Smtpsetting = withTranslation()(
  connect(null, mapDispatchToProps)(SmtpsettingClass)
);
